import Spin from 'antd/es/spin';
import { Navigate } from 'react-router-dom';

import ContentContainer from '@components/ContentContainer';
import { useAuthWhoami } from '@queries/auth';
import { useFetchTeamUsers } from '@queries/teams';

const TeamRootRedirect = () => {
  const authWhoamiQuery = useAuthWhoami();
  const userId = authWhoamiQuery.data?.userId;

  const fetchTeamQuery = useFetchTeamUsers({
    userIds: userId ? [userId] : undefined,
  });
  const teamId = fetchTeamQuery.data?.[0]?.teamId;

  if (fetchTeamQuery.isLoading || authWhoamiQuery.isLoading) {
    return <Spin />;
  }

  if (fetchTeamQuery.isError || authWhoamiQuery.isError) {
    return <ContentContainer.Error />;
  }

  if (!teamId) {
    return <Navigate to="/team/manage" replace />;
  }

  return <Navigate to={`/team/${teamId}`} replace />;
};

export default TeamRootRedirect;
